module.exports = __webpack_public_path__ + "static/media/destination.c1893e1a.png";